import React from 'react';

import { useTranslation } from 'react-i18next';
import { IconButton, useSidebar } from '@whelk/components';

import usePageName from '@whelk/hooks/src/usePageName';
import {
  AddNewChatIcon,
  OpenHistoryListIcon,
  QuestionnaireIcon,
} from '@whelk/assets/src/web/home-icon';

import ThemeToggle from '../ThemeToggle';
import UserInfo from '../UserInfo';
import { useChat } from '@whelk/hooks';
import useChatModel from '@whelk/hooks/src/useChatModel';
import { useSelector } from 'react-redux';
import { RootState } from '@whelk/store';
import { MinimaxLogo } from '@whelk/assets/src/web/brand-icons';

const MobileTopNav = () => {
  const { open, setOpen } = useSidebar();

  const { addNewChat, isNewChat } = useChat();
  const { modelName, modelOptions } = useChatModel();
  const chatTitle = useSelector((state: RootState) => state.chat.chatTitle);

  return (
    <>
      {/* 左边 */}
      <div onClick={() => setOpen(!open)} className='text-col_text00'>
        <OpenHistoryListIcon />
      </div>
      {isNewChat ? (
        <div className='flex w-[170px] items-center gap-4'>
          {/* {isNewChat && <ModelSelect client='mobile' />} */}
        </div>
      ) : (
        <div className='text-col_text00 flex max-w-[170px] flex-col items-center justify-center gap-[2px] truncate text-[16px]  font-[500] '>
          <span className='w-full truncate text-center'>{chatTitle}</span>
          {!!modelOptions?.length && (
            <span className='text-col_text02 text-[12px]'>{modelName}</span>
          )}
        </div>
      )}
      {/* 右边 */}
      <div className='flex items-center gap-4'>
        <div onClick={addNewChat} className='text-col_text00'>
          <AddNewChatIcon />
        </div>
      </div>
    </>
  );
};

const Header = () => {
  const { t } = useTranslation();
  // const { open, setOpen } = useSidebar();
  // const { addNewChat } = useChat();
  const { isHistoryPage } = usePageName();
  const { questionnaireUrl } = useSelector((state: RootState) => state.config);

  // // 创建新话题快捷键
  // useEffect(() => {
  //   const handleKeyDown = (e: KeyboardEvent) => {
  //     if (e.key === 'k' && (isWindows ? e.ctrlKey : e.metaKey)) {
  //       addNewChat();
  //     }
  //   };
  //   document.addEventListener('keydown', handleKeyDown);
  //   return () => {
  //     document.removeEventListener('keydown', handleKeyDown);
  //   };
  // }, []);

  const handleLogoClick = () => {
    window.location.href = 'https://agent.minimax.io/';
  };

  // 顶部 导航栏
  return (
    <>
      <header
        className={`relative z-[110] h-[54px] w-full overflow-hidden md:h-[60px] ${
          isHistoryPage ? 'hidden md:flex' : ''
        }`}
      >
        <div className='flex h-full w-full flex-1 items-center justify-between px-4 py-[10px] md:hidden'>
          <MobileTopNav />
        </div>
        <div className='hidden h-full w-full items-center justify-between bg-transparent pl-[20px] pr-[20px] shadow-none md:flex'>
          <div className='flex items-center'>
            <button className='text-col_accent04' onClick={handleLogoClick}>
              <MinimaxLogo height={28} width={120} />
            </button>
            {/* {!open && ( */}
            {/* <>
              <button
                onClick={addNewChat}
                className='text-col_text06 hover:bg-col_bg03 ml-2 flex h-[40px] items-center  gap-1 rounded-[8px] px-2'
              >
                <div className='h-5 w-5'>
                  <NewChatStarIcon />
                </div>
                <div className={`text-col_text00 whitespace-nowrap text-[15px] font-[500]`}>
                  {t('sidebar_new_chat')}
                </div>
              </button>
              <div className='bg-col_line01 mx-3 h-3 w-[1px]' />
            </> */}
            {/* )} */}
            {/* <div className='flex items-center'>
              <a
                className='decoration-none text-col_text00 cursor-pointer px-[12px] py-[10px] text-[15px] font-[500] leading-5'
                href='/'
              >
                Chat
              </a>
              <a
                target='_blank'
                href={isOverseas ? 'https://agent.minimax.io' : 'https://agent.minimaxi.com'}
                className='text-col_text01 mr-[12px] flex cursor-pointer items-center px-[12px]  py-[10px]  text-[15px] font-[400] leading-5'
                rel='noreferrer'
              >
                <p className='hover:text-col_text00 font-[500] '>Agent</p>
              </a>
            </div> */}
            {/* {isShowModelsPage && <ModelSelect client='pc' />} */}
          </div>
          <div className='flex items-center gap-4'>
            {!!questionnaireUrl && (
              <IconButton
                className='text-col_text06 hover:bg-col_bg03 ml-[6px] '
                tip={t('questionnaire_tip')}
                placement='bottom'
              >
                <a
                  href={questionnaireUrl}
                  target='_blank'
                  rel='noreferrer'
                  className='text-col_text00'
                >
                  <QuestionnaireIcon />
                </a>
              </IconButton>
            )}

            <div>
              <ThemeToggle />
            </div>
            <UserInfo />
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
